import React from 'react';
import { formatDate } from '../../utils/formatters';

export default function AlertList({ alerts, onToggle, onDelete }) {
  if (alerts.length === 0) {
    return <p className="empty-state">No alerts created yet.</p>;
  }

  return (
    <div className="alert-list">
      <h3>Active Alerts</h3>
      <table className="alert-table">
        <thead>
          <tr>
            <th>Name Pattern</th>
            <th>Extension</th>
            <th>Rarity</th>
            <th>Price Range</th>
            <th>Source</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {alerts.map((alert) => (
            <tr key={alert.id} className={!alert.is_active ? 'inactive' : ''}>
              <td>{alert.card_name_pattern || 'Any'}</td>
              <td>{alert.extension || 'Any'}</td>
              <td>{alert.rarity || 'Any'}</td>
              <td>
                {alert.min_price != null || alert.max_price != null
                  ? `${alert.min_price ?? '0'} - ${alert.max_price ?? '...'}`
                  : 'Any'}
              </td>
              <td>{alert.source || 'Any'}</td>
              <td>
                <span className={`status-badge ${alert.is_active ? 'status-active' : 'status-inactive'}`}>
                  {alert.is_active ? 'Active' : 'Paused'}
                </span>
              </td>
              <td>{formatDate(alert.created_at)}</td>
              <td>
                <button
                  className="btn btn-sm"
                  onClick={() => onToggle(alert.id, alert.is_active)}
                >
                  {alert.is_active ? 'Pause' : 'Resume'}
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => onDelete(alert.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
